
export const getCleanFileName = (url) => {
  if (!url) return "";
  try {
    const decoded = decodeURIComponent(url.split("?")[0]);
    const filename = decoded.split("/").pop();
    return filename.replace(/^\d+-/, "");
  } catch {
    return "Tài liệu đính kèm";
  }
};
